import { useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "sonner";
import { ApiError, api } from "~/core/api/index";
import { useI18n } from "~/core/i18n";
import { article } from "~/core/paths";

/**
 * Start an article on a question a reading turned up.
 *
 * A finding with no way to act on it was a dead end: FactCheck listed what the
 * engines got wrong and Opportunities what to write, and the only thing either
 * offered was reading. The question becomes a gap — the same one a person
 * could add on Content — so the article is briefed from the brand's facts like
 * any other, and the gap stays on Content if nobody finishes it.
 */
export function useWriteAbout(entityId: string, locale: string) {
	const navigate = useNavigate();
	const { locale: ui } = useI18n();
	const [busy, setBusy] = useState<string | null>(null);

	async function write(question: string) {
		setBusy(question);
		try {
			const gap = await api.addGap(entityId, question, locale);
			navigate(article(entityId, undefined, { gap: gap.id, locale }));
		} catch (e) {
			toast.error(e instanceof ApiError ? e.localized(ui) : String(e));
			setBusy(null);
		}
	}

	return { write, busy };
}
